/* eslint-disable no-debugger */
import { useEffect, useState } from "react";

import useBaseUsasClubData from "@usas/ui-web/state/clubBase/UseBaseUsasClubData";
import useSecurityData from '@usas/ui-web/state/security/UseSecurityData';
import useMeetFileData from "@usas/ui-web/state/meetFile/UseMeetFileData";

import useUsasClubFacilityLinksData from '../../../../../state/clubFacilityLinks/UseUsasClubFacilityLinksData';
import useMeetFormatData from "../../../../../state/meetFormat/UseMeetFormatData";
import useMeetSanctionConfigurationData from "../../../../../state/meetSanctionConfiguration/UseMeetSanctionConfigurationData";

import Constants from "@usas/ui-web/utils/Constants";

import { formatDate } from '@usas/ui-web/utils/DateFunctions';

const SAVING_ERROR_MSG = 'The last action is still saving. Please try again.';
const FILE_TYPE_ERROR_MSG = 'File type not permitted. Please provide a (*.pdf), (*.doc), or (*.docx) file.';

const UseMeetApprovedInfoForm = ({
  formState,
  setFormState,
  savedFormState,
  setIsDirty,
  meetState,
  hasUsasSanctionAccess,
  state,
  setState
}) => {
  const { baseUsasClubState } = useBaseUsasClubData();
  const { usasClubFacilityLinksState, getUsasClubFacilityLinks, clearUsasClubFacilityLinksArrayData } = useUsasClubFacilityLinksData();
  const { meetSanctionConfigurationState, getMeetSanctionConfiguration } = useMeetSanctionConfigurationData();

  const { meetFormatState, getMeetFormats } = useMeetFormatData();
  const [modalState, setModalState] = useState(getInitialModalState());
  const { securityState } = useSecurityData();
  const [removeFileModalState, setRemoveFileModalState] = useState(getInitialRemoveFileModalState());
  const { meetFileUploadState, postMeetFile, getMeetFile, getFileNameFromSavedUploadUrl, getFileNameFromUrl } = useMeetFileData();

  const [ competitionTypeState ] = useState([{ id: '--', name: '--' }, { id: 'Open', name: 'Open' }, { id: 'Closed', name: 'Closed' }]);

  const onOpenRemoveFileModalClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    setRemoveFileModalState({ ...removeFileModalState, fileName: formState.meetAnnouncementFileName, displayPopUp: true });
  }

  const onRemoveFileModalCanceled = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    setRemoveFileModalState({ ...getInitialRemoveFileModalState() });
  }

  const onUploadTemplateClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (meetFileUploadState.isObjLoading === true) {
      setState({ ...state, error: SAVING_ERROR_MSG });
    }
    else {
      setState({ ...state, error: '' });
      if (e.target.files[0]) {
        const file = e.target.files[0];
        const fileType = e.target.files[0].type;
        if (fileType === Constants.FILE_TYPE_PDF || fileType === Constants.FILE_TYPE_DOC ||
          fileType === Constants.FILE_TYPE_DOCX) {
          postMeetFile(file);
          setState({ ...state, error: '' });
        }
        else {
          setState({ ...state, error: FILE_TYPE_ERROR_MSG });
        }
      }
    }
  }

  const onRemoveTemplateClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    setRemoveFileModalState({ ...getInitialRemoveFileModalState() });
    if (meetFileUploadState.isSaving === true) {
      setState({ ...state, error: SAVING_ERROR_MSG });
    }
    else {
      setState({ ...state, error: '' });
      setFormState(prev => ({ ...prev, meetAnnouncementUrl: '', meetAnnouncementFileName: '' }));
    }
  }

  const onDownloadUploadedFile = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    showUploadedFile(formState.meetAnnouncementUrl);
  }

  async function showUploadedFile(fileUrl) {
    if (fileUrl) {
      const getFileResult = await getMeetFile(fileUrl);

      if (getFileResult) {
        if (getFileResult.objData?.blobFile?.size > 0) {
          var file = window.URL.createObjectURL(getFileResult.objData?.blobFile);
          const link = document.createElement('a');

          link.href = file;
          link.setAttribute('target', '_blank');
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        }
      }
    }
  }

  const onModalCancelClicked = () => {
    setModalState({
      ...getInitialModalState()
    });

    if (formState.depthRequirementMet === false && formState.isInWaterStart === false) {
      setFormState({
        ...formState, facilityId: Constants.DEFAULT_ID
      })
    }
  }

  function getFacilityById(facilityId) {
    return (usasClubFacilityLinksState.arrayData || []).find(
      x => x.facilityId === facilityId || x.facility?.facilityId === facilityId
    )?.facility;
  }

  function checkFacilityPoolDepthRequirement(facilityId) {
    const facility = getFacilityById(facilityId);

    if (!facility) {
      return false;
    }

    let requirementMet = false;

    if (meetState.isObjLoaded === true) {
      requirementMet = facility.depthRequirementMet || meetState.objData.isInWaterStart;
    } else {
      requirementMet = facility.depthRequirementMet || formState.isInWaterStart;
    }

    return requirementMet;
  }

  useEffect(() => {
    getMeetSanctionConfiguration(1);

    clearUsasClubFacilityLinksArrayData();

    if (meetFormatState.isArrayLoading !== true && meetFormatState.isArrayLoaded !== true) {
      getMeetFormats();
    }

    setFormState(prev => ({
      ...prev,
      ...savedFormState,
      autogeneratedMeetLsc: baseUsasClubState?.objData?.orgUnit?.parentOrgUnitCode || ''
    }));

    setIsDirty(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (meetState.isObjLoaded === true && savedFormState.meetId > 0 && formState.meetId < 0) {
      const selMeetClassification = [];

      if (meetState.objData?.meetClassification !== undefined) {
        selMeetClassification.push({ id: meetState.objData.meetClassification.meetClassificationId, name: meetState.objData.meetClassification.typeName });
      }

      const facilityId = meetState.objData?.facilityId || savedFormState.facilityId || Constants.DEFAULT_ID;
      const facilityNameFromLinks = getFacilityById(facilityId)?.facilityName || '';
      const facilityName = meetState.objData?.facility?.facilityName || savedFormState.facilityName || facilityNameFromLinks;

      const selMeetCourse = [];
      if (meetState.objData?.meetCourse !== undefined) {
        selMeetCourse.push({ id: meetState.objData.meetCourse[0].course.courseId, name: meetState.objData.meetCourse[0].course.courseCode });
      }

      if (meetState.objData?.meetCourse !== undefined && meetState.objData.meetCourse.length > 1) {
        selMeetCourse.push({ id: meetState.objData.meetCourse[1].course.courseId, name: meetState.objData.meetCourse[1].course.courseCode });
      }

      if (meetState.objData?.meetCourse !== undefined && meetState.objData.meetCourse.length > 2) {
        selMeetCourse.push({ id: meetState.objData.meetCourse[2].course.courseId, name: meetState.objData.meetCourse[2].course.courseCode });
      }

      const geographicFacilityLscOrgUnitId = meetState.objData?.geographicSanctionOrgUnitId || savedFormState.geographicFacilityLscOrgUnitId || Constants.DEFAULT_ID;
      const meetSoftwareId = meetState.objData?.meetSoftwareId || savedFormState.meetSoftwareId || Constants.DEFAULT_ID;
      const meetFormatId = meetState.objData?.meetFormatId || savedFormState.meetFormatId || Constants.DEFAULT_ID;
      const attestationSignature = savedFormState.attestationSignature || '';
      const meetAnnouncementUrl = meetState.objData?.meetAnnouncementUrl || savedFormState.meetAnnouncementUrl || '';

      setFormState(prev => ({
        ...prev,
        ...savedFormState,
        startDate: savedFormState.startDate ? formatDate(savedFormState.startDate) : Constants.BLANK_DATE_STRING,
        endDate: savedFormState.endDate ? formatDate(savedFormState.endDate) : Constants.BLANK_DATE_STRING,
        startDateOriginal: savedFormState.startDate ? formatDate(savedFormState.startDate) : Constants.BLANK_DATE_STRING,
        endDateOriginal: savedFormState.endDate ? formatDate(savedFormState.endDate) : Constants.BLANK_DATE_STRING,
        meetClassification: selMeetClassification,
        meetCourse: selMeetCourse,
        facilityId: facilityId,
        facilityName: facilityName,
        geographicFacilityLscOrgUnitId: geographicFacilityLscOrgUnitId,
        meetSoftwareId: meetSoftwareId,
        meetFormatId: meetFormatId,
        attestationSignature: attestationSignature,
        hasUsasSanctionAccess: hasUsasSanctionAccess,
        payorMemberId: meetState.objData?.payorMemberId || savedFormState.payorMemberId || '',
        payorPersonId: meetState.objData?.payorPersonId || savedFormState.payorPersonId || Constants.DEFAULT_ID,
        thisIsMe: savedFormState.payorMemberId === securityState?.userInfo?.memberId || false,
        status: meetState.objData?.status || '',
        openTypeAsApprovedMeetReason: savedFormState.openTypeAsApprovedMeetReason || '',
        isOpenWaterCompetition: savedFormState.isOpenWaterCompetition || false,
        isClubRequestingApproval: savedFormState.isClubRequestingApproval || false,
        meetAnnouncementUrl: meetAnnouncementUrl,
        meetAnnouncementFileName: meetAnnouncementUrl ? getFileNameFromUrl(meetAnnouncementUrl) : ''
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [savedFormState, meetState, usasClubFacilityLinksState.arrayData]);

  useEffect(() => {
    if (baseUsasClubState.isObjLoading === false && baseUsasClubState.isObjLoaded === true
      && usasClubFacilityLinksState.isArrayLoaded === false 
      && usasClubFacilityLinksState.isArrayLoading === false) {
      getUsasClubFacilityLinks(baseUsasClubState.objData.usasClubId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [baseUsasClubState, usasClubFacilityLinksState]);

  useEffect(() => {
    if (formState.facilityId > 0 && usasClubFacilityLinksState.isArrayLoaded === true) {
      let metRequirement = false;
      metRequirement = checkFacilityPoolDepthRequirement(formState.facilityId);
      const facilityName = getFacilityById(formState.facilityId)?.facilityName || '';

      setModalState({
        ...modalState,
        displayModal: !metRequirement,
        facilityName: facilityName
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formState.facilityId, usasClubFacilityLinksState.arrayData, usasClubFacilityLinksState.isArrayLoaded]);

  useEffect(() => {
    if (meetSanctionConfigurationState.isObjLoaded === true) {
      setFormState(prev => ({
        ...prev,
        pilotStartDate: meetSanctionConfigurationState.objData.startDate ? formatDate(meetSanctionConfigurationState.objData.startDate) : Constants.BLANK_DATE_STRING,
        pilotEndDate: meetSanctionConfigurationState.objData.endDate ? formatDate(meetSanctionConfigurationState.objData.endDate) : Constants.BLANK_DATE_STRING
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meetSanctionConfigurationState]);

  useEffect(() => {
    if (meetFileUploadState.isObjLoaded === true && Object.keys(meetFileUploadState.objData).length > 0) {
      setFormState(prev => ({
        ...prev,
        meetAnnouncementUrl: meetFileUploadState.objData.uploadUrl,
        meetAnnouncementFileName: getFileNameFromSavedUploadUrl()
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meetFileUploadState]);

  function getInitialModalState() {
    return {
      displayModal: false,
      facilityName: ''
    }
  }

  function getInitialRemoveFileModalState() {
    return {
      displayPopUp: false,
      fileName: '',
      modalTitle: 'Remove Uploaded File?'
    }
  }

  return {
    meetFormatState,
    modalState,
    meetSanctionConfigurationState,
    usasClubFacilityLinksState,
    competitionTypeState,
    onModalCancelClicked,
    meetFileUploadState,
    removeFileModalState,
    onUploadTemplateClicked,
    onOpenRemoveFileModalClicked,
    onRemoveFileModalCanceled,
    onRemoveTemplateClicked,
    onDownloadUploadedFile
  };
};

export default UseMeetApprovedInfoForm;